import React, { ReactNode, useMemo } from 'react'
import emptyImage from 'image/empty/empty_card_logo.png'
import DatePicker2 from 'meinian-package/src/component/filter2/datePicker2'
import { FormItem, UserFormItem } from './formItem'
import {
  SelectBlogSearchScope,
  SelectPlatform,
  SelectSampleSearchScope,
  SelectInspirationType,
  SelectQueryType,
  SelectMarkStatus,
  SelectSampleState,
} from './selectExtend'

export type SearchType = 'blog' | 'sample_clothing' | 'inspiration' | 'sample_folder'
export type CardItem = {
  id: number
  inspirationId: number
  name: string
  collectId: string
  parentId: number
  path: string
  namePath: string
  blogId: string
  userId: number
  markStatus: number
  markTimes: number
  platformId: number
  createdAt: string
  sampleCode: string
  reason: string
  mainUrl: string
  isPro: number
  needMarkTimes: number
}
export type Params = {
  searchType: SearchType
  userIdList?: string[]
  searchRangeList?: string[]
  start: number
  pageSize: number
  processParam?: string
  searchKey: string
  createdTimeStart?: string
  containChild?: boolean
  queryType?: number
  inspirationIdList?: string[]
  markStatus?: string
  createdTimeEnd?: string
  isPro?: number
  platformIdList?: string[]
}
export function getMainUrl(item) {
  return item.mainUrl || emptyImage
}

export type Config = {
  canFilterInspiration: boolean
  toDetail: (item: CardItem) => void
  filters: (params: Params, onChange: (p: Params) => void, data: unknown[]) => ReactNode
}

const CONFIGS: Record<string, Config> = {
  /**
   * 款式
   */
  blog: {
    canFilterInspiration: true,
    toDetail: (item: CardItem) => {
      window.open(
        `/meinian/detail/image?inspirationId=${item.inspirationId}&collectId=${item.collectId}&imageGroupEntityId=${item.blogId}`
      )
    },
    filters: (params: Params, onChange: (p: Params) => void, data) => {
      return (
        <>
          <FormItem label="搜索范围">
            <SelectBlogSearchScope
              value={params.searchRangeList}
              onChange={(val) => onChange({ ...params, searchRangeList: val })}
            />
          </FormItem>
          <FormItem label="款式来源">
            <SelectPlatform
              value={params.platformIdList}
              onChange={(val) => onChange({ ...params, platformIdList: val as string[] })}
            />
          </FormItem>
          <FormItem label="审核状态">
            <SelectMarkStatus value={params.markStatus} onChange={(val) => onChange({ ...params, markStatus: val as string })} />
          </FormItem>
          <UserFormItem
            label="采集用户"
            hasResult={data.length > 0}
            params={params}
            value={params.userIdList}
            onChange={(val) => onChange({ ...params, userIdList: val as string[] })}
          />
          <FormItem label="采集时间">
            <DatePicker2
              startTime={params.createdTimeStart}
              required={false}
              endTime={params.createdTimeEnd}
              onChange={([start, end]) => onChange({ ...params, createdTimeStart: start, createdTimeEnd: end })}
            />
          </FormItem>
        </>
      )
    },
  },
  /**
   * 样衣
   */
  sample_clothing: {
    canFilterInspiration: false,
    toDetail(item: CardItem) {
      window.open(`/meinian/detail/sample/image?sampleCode=${item.sampleCode}`)
    },
    filters(params, onChange, data) {
      return (
        <>
          <FormItem label="搜索范围">
            <SelectSampleSearchScope
              value={params.searchRangeList}
              onChange={(val) => onChange({ ...params, searchRangeList: val })}
            />
          </FormItem>
          <FormItem label="样衣状态">
            <SelectSampleState
              value={params.processParam}
              onChange={(val) => onChange({ ...params, processParam: val as string })}
            />
          </FormItem>

          <UserFormItem
            label="创建用户"
            params={params}
            hasResult={data.length > 0}
            value={params.userIdList}
            onChange={(val) => onChange({ ...params, userIdList: val as string[] })}
          />
          <FormItem label="创建时间">
            <DatePicker2
              startTime={params.createdTimeStart}
              required={false}
              endTime={params.createdTimeEnd}
              onChange={([start, end]) => onChange({ ...params, createdTimeStart: start, createdTimeEnd: end })}
            />
          </FormItem>
        </>
      )
    },
  },
  /**
   * 灵感集
   */
  inspiration: {
    canFilterInspiration: true,
    toDetail(item: CardItem) {
      window.open(`/meinian/home/coll/detail/${item.id}?inspirationId=${item.id}&parentId=${item.parentId > 0 ? item.parentId : ''}&tab=`)
    },
    filters(params, onChange, data) {
      return (
        <>
          <FormItem label="灵感集类型">
            <SelectInspirationType value={params.isPro} onChange={(val) => onChange({ ...params, isPro: val as number })} />
          </FormItem>
          <FormItem label="灵感集范围">
            <SelectQueryType value={params.queryType} onChange={(val) => onChange({ ...params, queryType: val as number })} />
          </FormItem>
          <UserFormItem
            label="拥有者"
            params={params}
            hasResult={data.length > 0}
            value={params.userIdList}
            onChange={(val) => onChange({ ...params, userIdList: val as string[] })}
          />
          <FormItem label="创建时间">
            <DatePicker2
              startTime={params.createdTimeStart}
              required={false}
              endTime={params.createdTimeEnd}
              onChange={([start, end]) => onChange({ ...params, createdTimeStart: start, createdTimeEnd: end })}
            />
          </FormItem>
        </>
      )
    },
  },
  /**
   * 样本文件夹
   */
  sample_folder: {
    canFilterInspiration: false,
    toDetail(item: CardItem) {
      window.open(`/meinian/home/sample?parentId=${item.id}`)
    },
    filters(params, onChange, data) {
      return (
        <>
          <UserFormItem
            label="创建用户"
            params={params}
            hasResult={data.length > 0}
            value={params.userIdList}
            onChange={(val) => onChange({ ...params, userIdList: val as string[] })}
          />
          <FormItem label="创建时间">
            <DatePicker2
              startTime={params.createdTimeStart}
              required={false}
              endTime={params.createdTimeEnd}
              onChange={([start, end]) => onChange({ ...params, createdTimeStart: start, createdTimeEnd: end })}
            />
          </FormItem>
        </>
      )
    },
  },
}
export function useConfig(type: SearchType) {
  const config: Config = useMemo(() => {
    return CONFIGS[type]
  }, [type])
  return config
}
